export default "__VITE_ASSET__CuJJf541__"